import { pdfLoadingProgress } from "../view-models/book-signals";
import { Customised } from "./custom-element";
import { html } from "uhtml";

export class CassisLoadingElement extends Customised(HTMLElement) {
	static tagName = "cassis-loading";
	signals() {
		return { progress: pdfLoadingProgress().percent };
	}
	render({ progress }) {
		if (progress === 100) {
			this.setAttribute("loaded", true);
		}
		return html`
		<label for="cassis-loading-progress">Loading progress:</label>
		<progress id="cassis-loading-progress" max="100" value="${progress}">${progress}%</progress>`;
	}
}
CassisLoadingElement.define();
